<div class="mb-2 flex justify-center">
  <div
    class="qaroni-label max-w-full"
    [ngClass]="center() ? 'text-center' : 'text-start'">
    {{ text() }}
  </div>
</div>
